<template>
  <div>
    <v-snackbar
      v-for="(item, index) in items"
      :key="item.id"
      v-model="item.show"
      :color="item.color"
      :timeout="item.timeout"
      top
      right
      :style="{ marginTop: `${index * 64}px` }"
      @input="onInput(item, $event)"
    >
      {{ item.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="close(item)">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { toastState, dismissToast } from "@/plugins/toast";

export default {
  name: "AppToast",
  computed: {
    items() {
      return toastState.items;
    },
  },
  methods: {
    onInput(item, value) {
      if (!value) {
        dismissToast(item.id);
      }
    },
    close(item) {
      dismissToast(item.id);
    },
  },
};
</script>
